// extracted by mini-css-extract-plugin
export var askAiIcon = "_ql-9";
export var container = "_ql-0";
export var groupSeparator = "_ql-a";
export var highlight = "_ql-4";
export var resultIcon = "_ql-5";
export var resultItem = "_ql-7";
export var resultSubtitle = "_ql-3";
export var resultTitle = "_ql-2";
export var resultsList = "_ql-1";
export var searchGroup = "_ql-6";
export var selected = "_ql-8";